import * as XLSX from 'xlsx';
import { Group } from '../types/group';

/**
 * Parse Excel file and convert it to Group objects
 * @param file The Excel file to parse
 * @returns Array of Group objects
 */
export const parseExcelToGroups = (file: File): Promise<Group[]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (e) => {
      try {
        const data = e.target?.result;
        console.log('Excel data loaded:', !!data);
        
        const workbook = XLSX.read(data, { type: 'array' });
        console.log('Workbook sheets:', workbook.SheetNames);
        
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        
        // First, get all data to understand the structure
        const allData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        console.log('All Excel data:', allData);
        
        // Skip the first row (title) and second row (headers), then extract data from column B onwards
        const dataRows = allData.slice(2); // Skip first 2 rows
        console.log('Data rows after skipping headers:', dataRows);
        
        // Map the data, taking columns B, C, D, E (indices 1, 2, 3, 4)
        const jsonData = dataRows.map((row: any) => {
          if (!row || row.length < 5) return null; // Skip invalid rows
          
          return {
            'Mã nhóm': row[1] || '', // Column B
            'Tên nhóm': row[2] || '', // Column C  
            'Thứ tự': row[3] || 0, // Column D
            'Trạng thái': row[4] || '' // Column E
          };
        }).filter(item => item && item['Mã nhóm']); // Filter out null/empty rows
        
        console.log('Parsed Excel data:', jsonData);
        
        // Map JSON data to Group objects
        const groups: Group[] = jsonData.map((row: any) => {
          console.log('Processing row:', row);
          
          // Create the group object with all available fields from Excel
          const group: Group = {
            code: String(row['Mã nhóm'] || '').trim(),
            name: String(row['Tên nhóm'] || '').trim(),
            displayOrder: Number(row['Thứ tự']) || 0,
            isActive: String(row['Trạng thái']).toLowerCase() === 'active' || row['Trạng thái'] === true || row['Trạng thái'] === 1
          };
          
          console.log('Created group object:', group);
          return group;
        }).filter(group => group.code && group.name); // Only keep groups with valid code and name
        
        console.log('Total groups parsed:', groups.length);
        resolve(groups);
      } catch (error) {
        console.error('Error parsing Excel:', error);
        reject(error);
      }
    };
    
    reader.onerror = (error) => {
      console.error('FileReader error:', error);
      reject(error);
    };
    
    reader.readAsArrayBuffer(file);
  });
};

/**
 * Generate a sample Excel template for group import
 * @returns Workbook object that can be used to download a template
 */
export const generateGroupExcelTemplate = (): XLSX.WorkBook => {
  // Define the header row and sample data
  const data = [
    ['Báo cáo nhóm món'], // Header row that will be skipped
    ['#', 'Mã nhóm', 'Tên nhóm', 'Thứ tự', 'Trạng thái'], // Column headers
    ['1', 'ITEM_TYPE_COFFEE', 'Cà phê', '1', 'Active'], // Sample data
    ['2', 'ITEM_TYPE_TEA', 'Trà', '2', 'Active'],
    ['3', 'ITEM_TYPE_CAKE', 'Bánh ngọt', '3', 'Active']
  ];
  
  // Create a worksheet with the data
  const ws = XLSX.utils.aoa_to_sheet(data);
  
  // Create a workbook with the worksheet
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Groups');
  
  return wb;
};

/**
 * Download Excel template for group import
 */
export const downloadGroupExcelTemplate = (): void => {
  const wb = generateGroupExcelTemplate();
  XLSX.writeFile(wb, 'list-category.xlsx');
}; 